import React, { useState, useRef } from 'react';
import s from './Contacto.module.css';
import { toastError, toastSuccess } from '../../helpers';
import ReCAPTCHA from "react-google-recaptcha";
import toast from 'react-hot-toast';

export default function Contacto({token}) {

    const [inputs, setInputs] = useState({nombre: "", apellido: "", empresa: "", email: "", posicion: "", texto: ""});
    const captchaRef = useRef(null)

    const handleInputs = function(e){
        setInputs((prev)=>({...prev, [e.target.name]: e.target.value}));
    }

    const handleSubmit = async function(e){
        e.preventDefault();

        const toastId = toast.loading('Enviando...');

        let captcha = captchaRef.current.getValue();

        if(!captcha){
            toastError("Complete la verificacón");
            return;
        }

        try{
            await fetch(`http://peuma-ig.com.ar/servicios/grabarcontacto.php?token=${token}`, {
                method: 'POST',
                body: JSON.stringify({
                    captcha: captcha,
                    nombre: inputs.nombre,
                    apellido: inputs.apellido,
                    empresa: inputs.empresa,
                    email: inputs.email,
                    comentario: inputs.texto,
                    posicion: inputs.posicion
                })
            })
            .then(response => response.json())
            .then(data => {
                toast.dismiss(toastId);
                console.log(data)
                toastSuccess("El mensaje fue enviado correctamente");
            });

            captchaRef.current.reset();

        }catch(e){
            console.log(e)
            toast.dismiss(toastId);
            toastError("Ocurrió un error inesperado, intentalo mas tarde");
        }

    }

    return (
        <section className={s.section} id="Contacto">
            <h3>Contacto</h3>
            <form className={s.form} onSubmit={handleSubmit}>
                <div className={s.row}>
                    <input type="text" name="nombre" placeholder='Nombre' onChange={handleInputs} required/>
                    <input type="text" name="apellido" placeholder='Apellido' onChange={handleInputs} required/>
                </div>
                <div className={s.row}>
                    <input type="text" name="empresa" placeholder='Empresa' onChange={handleInputs} required/>
                    <input type="text" name="email" placeholder='Email' onChange={handleInputs} required/>
                </div>
                <input type="text" name="posicion" placeholder='Posición' onChange={handleInputs} required/>
                <textarea name="texto" onChange={handleInputs} required placeholder='Cuéntenos un poco de su empresa, y si quiere que lo llamemos, escriba su número de teléfono y disponibilidad horaria.'/>
                <ReCAPTCHA
                    ref={captchaRef}
                    sitekey="6LfBKoAUAAAAAMpj5TfPw9Yy5sfkg3N4OOD0mm_O"
                />
                <button type='submit'>ENVIAR</button>
            </form>
        </section>
    )
}